import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '~/Actions';
import {
  Select,
  MenuItem,
  TableRow,
  TableCell,
  TableHead,
  TableContainer,
  TableBody,
  Table,
} from '@material-ui/core';
import { ArrowBackIos, ArrowForwardIos, FirstPage, LastPage } from '@mui/icons-material';

import { S_Input, S_Btn_Search, S_Btn_Add, S_DateInput } from '~/components/SearchItem';
import { T_TitleCell, T_Btn_Function, T_TableRow } from '~/components/TableItem';
import T_common from '~/components/TableItem/common';
import PageTitle from '~/components/PageTitle';
import UserCheckActive from '~/components/Dialog/UserCheckActive';
import CheckExport from '~/components/Dialog/CheckExport';
import AddAndEdit from './AddAndEdit';
import RecordView from './RecordView';

const returnDate = d => `${d.getFullYear()}/${(d.getMonth() + 1) > 9 ? (d.getMonth() + 1) : `0${d.getMonth() + 1}`}/${d.getDate() > 9 ? d.getDate() : `0${d.getDate()}`}`;

class App extends Component {
  constructor (props) {
    super(props);
    this.state = {
      user_check_name: '',
      start_date: '',
      end_date: '',
      per_page: 10,
      page: 1,
      sort: true,
      sort_field: 'user_check.upd_time',
      view_checkDelete: false,
      view_addAndEdit: false,
      view_view: false,
      view_checkActive: false,
      mode_addAndEdit: '',
      currentId: '',
      currentAct: '',
      dialog_Export: false,
    };
  }

  componentDidMount () {
    this.exportFunc = () => {};
    this.logCount = 0;
    const { user_check_name, start_date, end_date } = this.state;
    this.data = { user_check_name, start_date, end_date };
    this.refresh();
  }

  refresh=() => {
    const { page, per_page, sort, sort_field } = this.state;
    const { user_check_name, start_date, end_date } = this.data;
    const body = {
      user_check_name,
      sort: sort ? 'desc' : 'asc',
      sort_field,
      start_date: start_date.toString().length > 0 ? returnDate(start_date) : '',
      end_date: end_date.toString().length > 0 ? returnDate(end_date) : '',
    };
    this.props.getCheckPageList({
      page,
      per_page,
      body,
    });
  }

  search=() => this.setState({ page: 1 }, () => this.refresh());

  _click_search=() => {
    const { openCheckTime } = this.props;
    const { user_check_name, start_date, end_date } = this.state;
    this.data = { user_check_name, start_date, end_date };
    this.search();

    const error = (start_date.toString().length > 0 && end_date.toString().length > 0) && (start_date > end_date);
    if (error)openCheckTime();
  }

  _add=() => this.setState({ view_addAndEdit: true, mode_addAndEdit: 'add' })
  // _view=id => this.setState({ currentId: id, view_addAndEdit: true, mode_addAndEdit: 'view' })
  _view=id => this.setState({ currentId: id, view_view: true })
  _edit=id => this.setState({ currentId: id, view_addAndEdit: true, mode_addAndEdit: 'edit' })
  _checkActive=id => this.setState({ currentId: id, view_checkActive: true })
  _close_view=() => {
    this.refresh();
    this.setState({ currentId: '', view_addAndEdit: false, mode_addAndEdit: '', view_view: false, view_checkActive: false });
  }

  toolBar=() => {
    const { user_check_name, start_date, end_date } = this.state;
    const error = (start_date.toString().length > 0 && end_date.toString().length > 0) && (start_date > end_date);
    return (
      <div style={{ marginTop: 24, display: 'flex', minHeight: 84, backgroundColor: 'white', boxShadow: '0px 4px 6px rgba(62, 73, 84, 0.04)', borderRadius: 5, alignItems: 'center', paddingLeft: 13, paddingRight: 51 }}>
        <div style={{ color: error ? 'red' : '#333333', fontSize: 16, marginRight: 12 }}>清查日期</div>
        <S_DateInput height={46} error={error} value={start_date} onChange={t => this.setState({ start_date: t })} />
        <div style={{ color: '#333333', fontSize: 16, marginRight: 7, marginLeft: 7 }}>~</div>
        <S_DateInput height={46} error={error} value={end_date} onChange={t => this.setState({ end_date: t })} />
        <div style={{ color: '#333333', fontSize: 16, marginLeft: 22, marginRight: 12 }}>清查名稱</div>
        <S_Input height={46} width={298} hint='請輸入名稱' value={user_check_name} onChange={d => { this.setState({ user_check_name: d }); }} onEnterKey={this._click_search} />
        <S_Btn_Search style={{ marginLeft: 51, width: 66, height: 40 }} onClick={this._click_search} />
      </div>
    );
  }

  toolBar2=() => (
    <div style={{ marginTop: 24, display: 'flex', alignItems: 'center' }}>
      <div style={{ color: '#064B6F', fontSize: 20, lineHeight: '24px', letterSpacing: '0.25%' }}>清查紀錄</div>
      <S_Btn_Add onClick={this._add} style={{ marginLeft: 24 }} />
    </div>
  )

  renderTableTitle=() => {
    const { sort, sort_field } = this.state;
    const onChangeSort = t => {
      this.setState({ sort_field: t, sort: sort_field === t ? !sort : false }, () => this.search());
    };
    const ary = [
      { name: '序號' },
      { name: '清查名稱', id: 'user_check.name' },
      { name: '清查日期（起）', id: 'user_check.start_date' },
      { name: '清查日期（迄）', id: 'user_check.end_date' },
      { name: '狀態', id: 'user_check.status' },
      { name: '功能' },
    ];
    return (
      <TableHead>
        <TableRow style={{ height: 48 }}>
          {ary.map((o, i) => (
            <T_TitleCell
              key={i}
              text={o.name}
              arrow={!!o.id}
              bol={sort_field === o.id ? sort : true}
              onClick={() => onChangeSort(o.id)}
            />
          ))}
        </TableRow>
      </TableHead>
    );
  }

  renderTableBody=() => {
    const { checkPageList = {}, exportCheckIdExcel } = this.props;
    const { user_check_list = [], page = 0, total = 0 } = checkPageList;
    const { per_page } = this.state;
    const statusInfo = { 0: { text: '未啟動', color: '#1A63AC' }, 1: { text: '作業中', color: '#FF0000' }, 2: { text: '已結束', color: '#979797' } };
    const cellStyle = { fontSize: 14 };
    let start = 0;
    if (page > 0) {
      start = (page - 1) * per_page + 1;
      if (start > total)start = 0;
    }
    return (
      <TableBody>
        {user_check_list.map((o, i) => (
          <T_TableRow key={i} backgroundColor= {i % 2 === 0 ? '#E0FDFF' : 'white'}>
            <TableCell align='center' style={cellStyle}>{i + start}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.user_check_name}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.start_date}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.end_date}</TableCell>
            <TableCell align='center' style={{ ...cellStyle, color: statusInfo[o.status].color }}>{statusInfo[o.status].text}</TableCell>
            <TableCell style={{ width: 214 }}>
              <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                {o.status !== '2' && <T_Btn_Function text='編輯' backgroundColor={T_common.type1} onClick={() => this._edit(o.id)} />}
                {o.status === '2' && <div style={{ width: 66 }} />}
                {o.status === '0' && <T_Btn_Function text='啟動' backgroundColor={'#FF7A00'} onClick={() => this._checkActive(o.id)} style={{ marginLeft: 8, marginRight: 8 }} />}
                {o.status !== '0' && <T_Btn_Function text='檢視紀錄' backgroundColor={T_common.type2} width={90} onClick={() => this._view(o.id)} style={{ marginLeft: 8, marginRight: 8 }} />}
                {o.status !== '0' && <T_Btn_Function text='匯出' backgroundColor={T_common.type3} onClick={() => { this.exportFunc = () => exportCheckIdExcel(o.id, o.user_check_name); this.logCount = o.log_count; this.setState({ dialog_Export: true }); }} />}
              </div>
            </TableCell>
          </T_TableRow>
        ))}
      </TableBody>
    );
  }

  renderTableBar=() => {
    const { checkPageList = {} } = this.props;
    const { has_next = false, has_prev = false, page = 0, pages = 0, total = 0 } = checkPageList;
    const { per_page, page: statePage } = this.state;
    const returnPages = () => {
      const array = [];
      for (let i = 1; i <= pages; i++) {
        array.push(i);
      }
      return array;
    };
    const returnPers = () => [10, 20, 30, 40]
    ;
    const canFirst = page > 1;
    const canLast = page < pages;
    return (
      <div style={{ height: 48, display: 'flex', alignItems: 'center', width: '98%', backgroundColor: 'white', borderBottomRightRadius: 8, borderBottomLeftRadius: 8, paddingTop: 6, paddingBottom: 6 }}>
        <div style={{ flex: 1 }} />
        <FirstPage style={{ height: 24, width: 24, color: canFirst ? 'black' : 'gray', cursor: canFirst ? 'pointer' : 'default' }} onClick={() => { if (canFirst) this.setState({ page: 1 }, () => this.refresh()); }} />
        <ArrowBackIos style={{ marginLeft: 3, marginRight: 5, height: 16, width: 16, color: has_prev ? 'black' : 'gray', cursor: has_prev ? 'pointer' : 'default' }} onClick={() => { if (has_prev) this.setState({ page: this.state.page - 1 }, () => this.refresh()); }} />
        <div style={{ fontSize: 14 }}>第</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px', marginRight: 8, marginLeft: 8 }}
          variant="outlined"
          value={statePage}
          onChange={e => this.setState({ page: e.target.value }, () => { this.refresh(); })}
        >
          {returnPages().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginRight: 8 }}>{`/${pages} 頁，每頁`}</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px' }}
          variant="outlined"
          value={per_page}
          onChange={e => this.setState({ per_page: e.target.value }, () => { this.search(); })}
        >
          {returnPers().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginLeft: 8 }}>{`筆，共${total}筆`}</div>
        <ArrowForwardIos style={{ marginLeft: 5, height: 16, width: 16, color: has_next ? 'black' : 'gray', cursor: has_next ? 'pointer' : 'default' }} onClick={() => { if (has_next) this.setState({ page: this.state.page + 1 }, () => this.refresh()); }} />
        <LastPage style={{ marginRight: 19, height: 24, width: 24, color: canLast ? 'black' : 'gray', cursor: canLast ? 'pointer' : 'default' }} onClick={() => { if (canLast) this.setState({ page: pages }, () => this.refresh()); }} />
        <div style={{ flex: 1 }} />
      </div>
    );
  }

  renderTable=() => {
    const { checkPageList = {} } = this.props;
    const { user_check_list = [] } = checkPageList;
    const haveData = user_check_list.length > 0;
    return (
      <TableContainer style={{ marginTop: 18, maxWidth: '98%' }}>
        <Table style={{ backgroundColor: 'white', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
          {this.renderTableTitle()}
          {haveData && this.renderTableBody()}
        </Table>
      </TableContainer>
    );
  }

  renderMainPage=() => {
    const { checkPageList = {} } = this.props;
    const { view_checkActive, currentId, dialog_Export } = this.state;
    const { user_check_list = [] } = checkPageList;
    const haveData = user_check_list.length > 0;
    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text='清查作業' />
        {this.toolBar()}
        {this.toolBar2()}
        {this.renderTable()}
        {haveData && this.renderTableBar()}
        {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
        <UserCheckActive open={view_checkActive} id={currentId} onClose={this._close_view} search={this.refresh} />
        {dialog_Export && <CheckExport num={this.logCount} isCsv={false} onExport={this.exportFunc} onClose={() => { this.exportFunc = () => {}; this.logCount = 0; this.setState({ dialog_Export: false }); }} />}
      </div>
    );
  }

  render () {
    const { currentId, view_addAndEdit, view_view, mode_addAndEdit } = this.state;
    if (view_view) return <RecordView id={currentId} _onClose={this._close_view} />;
    else if (view_addAndEdit) return <AddAndEdit id={currentId} mode={mode_addAndEdit} _onClose={this._close_view} />;
    return this.renderMainPage();
    // return !view_addAndEdit
    //   ? this.renderMainPage()
    //   : <AddAndEdit id={currentId} mode={mode_addAndEdit} _onClose={this._close_view} />;
  }
}
const mapStateToProps = state => ({
  checkPageList: state.data.CheckPageList,
});
const mapDispatchToProps = dispatch => ({
  getCheckPageList: body => Actions.getCheckPageList(dispatch, body),
  exportCheckIdExcel: (id, name) => Actions.exportCheckIdExcel(dispatch, { id, name }),
  openCheckTime: () => Actions.openCheckTime(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
